import { apiGet, getApiBaseUrl } from './client';

// Fetch worker attribute update events from backend with optional SSE progress
export async function fetchWorkerAttributeEvents({ date, from, to, env = 'memo', options = {} }) {
  const base = getApiBaseUrl();
  const params = new URLSearchParams({ date, from, to, env, progress: '1' });
  if (options.sliceMinutes) params.set('sliceMinutes', String(options.sliceMinutes));
  if (options.limit) params.set('limit', String(options.limit));
  if (options.maxTotalEvents) params.set('maxTotalEvents', String(options.maxTotalEvents));

  const streamUrl = `${base}/worker-attribute-events?${params.toString()}`;

  function openProgress(onMeta, onProgress, onDone, onError) {
    const es = new EventSource(streamUrl);
    es.addEventListener('meta', (e) => { try { onMeta && onMeta(JSON.parse(e.data)); } catch(_){} });
    es.addEventListener('progress', (e) => { try { onProgress && onProgress(JSON.parse(e.data)); } catch(_){} });
    es.addEventListener('done', (e) => { try { onDone && onDone(JSON.parse(e.data)); } catch(_){} es.close(); });
    es.onerror = (e) => { try { onError && onError(e); } finally { es.close(); } };
    return es;
  }

  async function fetchFinal() {
    return apiGet('/worker-attribute-events', { params: { date, from, to, env, sliceMinutes: options.sliceMinutes, limit: options.limit, maxTotalEvents: options.maxTotalEvents } });
  }

  return { openProgress, fetchFinal };
}